export function doWhen(callback: () => void, conditionFunction: () => boolean, checkInterval = 100) {
	setTimeout(() => {
		if (conditionFunction()) {
			callback();
		} else {
			doWhen(callback, conditionFunction, checkInterval);
		}
	}, checkInterval);
}
